import { useState, type FormEvent } from "react";
import { Icon } from "./icons";
import { BRAND_NAME_RU } from "./brand";

interface LoginScreenProps {
  mode: "login" | "unavailable";
  onLogin: (username: string, password: string) => Promise<void>;
  onRetry: () => void;
}

export function LoginScreen({ mode, onLogin, onRetry }: LoginScreenProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await onLogin(username, password);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Не удалось войти");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="auth-shell">
      <section className="auth-aside">
        <div className="auth-brand"><div className="brand__mark"><span/><span/></div><div><strong>{BRAND_NAME_RU}</strong><small>управление аптекой</small></div></div>
        <div className="auth-aside__status"><span className="status-dot status-dot--online"/><span>Защищённый доступ к рабочему пространству</span></div>
      </section>
      <section className="auth-main">
        {mode === "unavailable" ? (
          <div className="auth-card auth-card--message"><div className="auth-card__icon"><Icon name="settings" size={25}/></div><p className="eyebrow">Соединение</p><h1>Сервер недоступен</h1><p>Проверьте подключение к сети и повторите попытку.</p><button className="primary-button auth-submit" onClick={onRetry}>Повторить подключение</button></div>
        ) : (
          <form className="auth-card" onSubmit={submit}>
            <p className="eyebrow">ФармХаб</p><h1>Вход в систему</h1><p>Используйте личную учётную запись.</p>
            <label className="auth-field"><span>Логин</span><div><Icon name="users" size={18}/><input autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} placeholder="Ваш логин" required autoFocus/></div></label>
            <label className="auth-field"><span>Пароль</span><div><Icon name="settings" size={18}/><input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Ваш пароль" required/></div></label>
            {error && <div className="auth-error" role="alert">{error}</div>}
            <button className="primary-button auth-submit" disabled={submitting}>{submitting ? "Проверяем…" : "Войти"}<Icon name="arrow" size={17}/></button>
            <div className="auth-security"><Icon name="check" size={15}/><span>Пароль не сохраняется в браузере</span></div>
          </form>
        )}
      </section>
    </main>
  );
}
